module.exports = __webpack_public_path__ + "static/media/retail2.4561a623.png";